export default [
  { value: "5", text: "Rede" },
  { value: "20", text: "Cielo" },
];
